<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-acknowledgments element-with-heading" id="acknowledgments">
<div class="heading heading-with-title heading-without-image" id="acknowledgments-heading">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title">Acknowledgments</h1>
</div>
</div>
</div>
</div>
<div class="text" id="acknowledgments-text">
<p class="first first-in-chapter first-full-width">Special thanks goes out to:  The Creator from whom all Blessings and opportunities flow, Sesvalah, my son, J. L. Woodson (for the awesome cover designs for the Knights of the Castle and the Kings of the Castle series), Janice M. Allen, Debra J. Mitchell, Royce Slade Morton, Bunny Ervin, J. L. Campbell, Kelly Peterson, Janine A. Ingram, Ehryck F. Gilmore, LaVerne Thompson, Kassanna Dwight, Vikkas Bhardwaj (our amazing cover model), Ella Houston, Betty Clawson, Amanda McCoy, Ellen Kiley Goeckler, Brynn Weimer, Theresa V. Wilson, Stephanie Fazekus-Hardy, Stephanie M. Freeman, Shae Cross, J. D. Mason, Unique Hiram, Siera London, Elizabeth Means, April Bubb, King Brooks, the Kings of the Castle Ambassadors, Members of Naleighna Kai’s Literary Cafe, the members of NK Tribe Called Success, the members of Namakir Tribe, and to you, my dear readers . . . thank you all for your support.</p>
<hr class="implicit-break"/>
<p class="first first-in-section first-full-width">Much love, peace, and joy,</p>
<p class="subsq">Naleighna Kai</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// acknowledgments.vue?02e2b11a